import * as THREE from 'three';
import Assets from "./../assets";


// const vertexShader = `varying vec3 worldNormal;
// varying vec3 eyeVector;

// void main() {
//   vec4 worldPos = modelMatrix * vec4(position, 1.0);
//   vec4 mvPosition = viewMatrix * worldPos;

//   gl_Position = projectionMatrix * mvPosition;
//   worldNormal = normalize(modelMatrix * vec4(normal, 0.0)).xyz;
//   eyeVector =  normalize(worldPos.xyz - cameraPosition);
// }
// `;

// const fragmentShader = `uniform float uIorR;
// uniform float uIorY;
// uniform float uIorG;
// uniform float uIorC;
// uniform float uIorB;
// uniform float uIorP;

// uniform float uSaturation;
// uniform float uChromaticAberration;
// uniform float uRefractPower;
// uniform float uFresnelPower;
// uniform float uShininess;
// uniform float uDiffuseness;
// uniform vec3 uLight;

// uniform vec2 winResolution;
// uniform sampler2D uTexture;

// varying vec3 worldNormal;
// varying vec3 eyeVector;

// vec3 sat(vec3 rgb, float adjustment) {
//   const vec3 W = vec3(0.2125, 0.7154, 0.0721);
//   vec3 intensity = vec3(dot(rgb, W));
//   return mix(intensity, rgb, adjustment);
// }

// float fresnel(vec3 eyeVector, vec3 worldNormal, float power) {
//   float fresnelFactor = abs(dot(eyeVector, worldNormal));
//   float inversefresnelFactor = 1.0 - fresnelFactor;
  
//   return pow(inversefresnelFactor, power);
// }

// float specular(vec3 light, float shininess, float diffuseness) {
//   vec3 normal = worldNormal;
//   vec3 lightVector = normalize(-light);
//   vec3 halfVector = normalize(eyeVector + lightVector);

//   float NdotL = dot(normal, lightVector);
//   float NdotH =  dot(normal, halfVector);
//   float kDiffuse = max(0.0, NdotL);
//   float NdotH2 = NdotH * NdotH;

//   float kSpecular = pow(NdotH2, shininess);
//   return  kSpecular + kDiffuse * diffuseness;
// }

// const int LOOP = 16;

// void main() {
//   float iorRatioRed = 1.0/uIorR;
//   float iorRatioGreen = 1.0/uIorG;
//   float iorRatioBlue = 1.0/uIorB;

//   vec2 uv = gl_FragCoord.xy / winResolution.xy;
//   vec3 normal = worldNormal;
//   vec3 color = vec3(0.0);

//   for ( int i = 0; i < LOOP; i ++ ) {
//     float slide = float(i) / float(LOOP) * 0.1;

//     vec3 refractVecR = refract(eyeVector, normal,(1.0/uIorR));
//     vec3 refractVecY = refract(eyeVector, normal, (1.0/uIorY));
//     vec3 refractVecG = refract(eyeVector, normal, (1.0/uIorG));
//     vec3 refractVecC = refract(eyeVector, normal, (1.0/uIorC));
//     vec3 refractVecB = refract(eyeVector, normal, (1.0/uIorB));
//     vec3 refractVecP = refract(eyeVector, normal, (1.0/uIorP));

//     float r = texture2D(uTexture, uv + refractVecR.xy * (uRefractPower + slide * 1.0) * uChromaticAberration).x * 0.5;

//     float y = (texture2D(uTexture, uv + refractVecY.xy * (uRefractPower + slide * 1.0) * uChromaticAberration).x * 2.0 +
//                 texture2D(uTexture, uv + refractVecY.xy * (uRefractPower + slide * 1.0) * uChromaticAberration).y * 2.0 -
//                 texture2D(uTexture, uv + refractVecY.xy * (uRefractPower + slide * 1.0) * uChromaticAberration).z) / 6.0;

//     float g = texture2D(uTexture, uv + refractVecG.xy * (uRefractPower + slide * 2.0) * uChromaticAberration).y * 0.5;

//     float c = (texture2D(uTexture, uv + refractVecC.xy * (uRefractPower + slide * 2.5) * uChromaticAberration).y * 2.0 +
//                 texture2D(uTexture, uv + refractVecC.xy * (uRefractPower + slide * 2.5) * uChromaticAberration).z * 2.0 -
//                 texture2D(uTexture, uv + refractVecC.xy * (uRefractPower + slide * 2.5) * uChromaticAberration).x) / 6.0;
          
//     float b = texture2D(uTexture, uv + refractVecB.xy * (uRefractPower + slide * 3.0) * uChromaticAberration).z * 0.5;

//     float p = (texture2D(uTexture, uv + refractVecP.xy * (uRefractPower + slide * 1.0) * uChromaticAberration).z * 2.0 +
//                 texture2D(uTexture, uv + refractVecP.xy * (uRefractPower + slide * 1.0) * uChromaticAberration).x * 2.0 -
//                 texture2D(uTexture, uv + refractVecP.xy * (uRefractPower + slide * 1.0) * uChromaticAberration).y) / 6.0;

//     float R = r + (2.0*p + 2.0*y - c)/3.0;
//     float G = g + (2.0*y + 2.0*c - p)/3.0;
//     float B = b + (2.0*c + 2.0*p - y)/3.0;

//     color.r += R;
//     color.g += G;
//     color.b += B;

//     color = sat(color, uSaturation);
//   }

//   // Divide by the number of layers to normalize colors (rgb values can be worth up to the value of LOOP)
//   color /= float( LOOP );

//   // Specular
//   float specularLight = specular(uLight, uShininess, uDiffuseness);
//   color += specularLight;

//   // Fresnel
//   float f = fresnel(eyeVector, normal, uFresnelPower);
//   color.rgb += f * vec3(1.0);

//   gl_FragColor = vec4(color, 1.0);
//   #include <tonemapping_fragment>
//   #include <colorspace_fragment>
// }`;


export default class Logo {
    constructor({ scene }) {
        this.scene = scene;
        this.model = null;
        this.rotor = new THREE.Group();
        this.rotor2 = new THREE.Group();
        this.rectangle = null;
        this.rectangle2 = null;
        this.rectangle3 = null;
        this.scene.add(this.rotor)
        this.scene.add(this.rotor2)

		// const uniforms = {
		// 	uTexture: {
		// 		value: null
		// 	},
		// 	uIorR: { value: 1.15 },
		// 	uIorY: { value: 1.16 },
		// 	uIorG: { value: 1.18 },
		// 	uIorC: { value: 1.22 },
		// 	uIorB: { value: 1.22 },
		// 	uIorP: { value: 1.22 },
		// 	uRefractPower: {
		// 		value: 0.2
		// 	},
		// 	uChromaticAberration: {
		// 		value: 0.6
		// 	},
		// 	uSaturation: { value: 0.9 },
		// 	uShininess: { value: 15.0 },
		// 	uDiffuseness: { value: 0.2 },
		// 	uFresnelPower: { value: 8.0 },
		// 	uLight: {
		// 		value: new THREE.Vector3(-1.0, 1.0, 1.0)
		// 	},
		// 	winResolution: {
		// 		value: new THREE.Vector2(window.innerWidth, window.innerHeight)
		// 	}
		// };
        // this.material = new THREE.ShaderMaterial({
		// 	vertexShader,
		// 	fragmentShader,
		// 	uniforms
		// }); 
    }

    initialize() {
        const geometry = new THREE.PlaneGeometry(1, 3); // Width 2, Height 1
        const material = new THREE.MeshBasicMaterial({ 
            color: 0xffffff, 
            side: THREE.DoubleSide 
        });
        
        this.rectangle = new THREE.Mesh(geometry, material);
        this.rectangle.layers.set(1);

        this.scene.add(this.rectangle);

        const geometry2 = new THREE.PlaneGeometry(1, 3);
        
        this.rectangle2 = new THREE.Mesh(geometry2, material);
        this.rectangle2.layers.set(1);
        this.rectangle2.position.x = -2
        this.rectangle2.rotation.y = -0.2
        this.rectangle2.rotation.z = -0.5

        this.scene.add(this.rectangle2);

        const geometry3 = new THREE.PlaneGeometry(1, 3);
        
        this.rectangle3 = new THREE.Mesh(geometry3, material);
        this.rectangle3.layers.set(1);
        this.rectangle3.position.x = 3.
        this.rectangle3.rotation.y = 0.2
        this.rectangle3.rotation.z = 0.5

        this.scene.add(this.rectangle3);


        const logoGeometry = new THREE.PlaneGeometry(3, 3); // Width 2, Height 1
        const logoMaterial = new THREE.MeshBasicMaterial({ 
            // color: 0xff0000, 
            side: THREE.DoubleSide,
            map: Assets.logoPng
        });
        
        this.logo = new THREE.Mesh(logoGeometry, logoMaterial);
        this.logo.position.z = -3.
        this.scene.add(this.logo);


        if (Assets.logo) {
            this.model = Assets.logo
            this.logo.add(this.model)
            this.model.rotation.x = -0.25 * 0.25
            this.model.rotation.z = -0.0625 * 0.25
        } else {
            
            Assets.manager.onLoad = () => {
                this.model = Assets.logo
                this.rotor.add(this.model)
                this.rotor2.add(this.model.clone())
                // this.scene.traverse(mesh => {
                //     if (mesh.isMesh) {
                //         mesh.material = this.material
                //     }
                // })
                this.rotor.children[0].rotation.x = -0.25 * 0.25
                this.rotor.children[0].rotation.z = -0.0625 * 0.25
                this.rotor2.children[0].rotation.x = -0.25 * 0.25
                this.rotor2.children[0].rotation.z = -0.0625 * 0.25
            }
        }
    }

    handleRender() {
        // if (this.model) {
        //     this.model.rotation.z = -0.0325
        // }
    }

    dispose() {
        if (this.mesh) {
            this.mesh.geometry.dispose();
            this.mesh.material.dispose();
            this.scene.remove(this.mesh);
        }
    }
}